import type { TClient } from './user';

export enum EBookingStatus {
  ACTIVE = 'ACTIVE',
  FINISHED = 'FINISHED',
  CANCELED = 'CANCELED',
  REDEEMED = 'REDEEMED',
  REDEEMED_AUTO = 'REDEEMED_AUTO',
}

export interface Booking {
  id: number;
  from: string;
  to: string;
  group: string | null;
}

export interface BookingHost {
  id: number;
  position: number;
  group_id: number;
  alias: string;
  client_sessions: Array<{
    id: number;
    finished_at: string;
    started_at: string;
  }>;
  bookings: Array<Booking>;
}

export interface BookingHostGroup {
  id: number;
  title: string;
}

export interface IBooking {
  id: number;
  client?: Pick<TClient, 'id' | 'uuid'>;
  status: EBookingStatus;
  from: string;
  to: string;
  comment?: string;
  group: string | null;
  hostIds: Array<number>;
}
